import { render, staticRenderFns } from "./ModalMessagePreview.vue?vue&type=template&id=22223265&scoped=true&"
import script from "./ModalMessagePreview.vue?vue&type=script&lang=js&"
export * from "./ModalMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessagePreview.vue?vue&type=style&index=0&id=22223265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22223265",
  null
  
)

export default component.exports